/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CashFund } from '../models/cash-fund';
import { CashFundStatus } from '../models/cash-fund-status';
import { CashFundUpdateDto } from '../models/cash-fund-update-dto';
import { UserSummary } from '../models/user-summary';

/**
 * Cash funds
 */
@Injectable({
  providedIn: 'root',
})
export class CashFundsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /**
   * Path part for operation getCashFund
   */
  static readonly GetCashFundPath = '/api/mobile/cashfunds/{cashFundId}';

  /**
   * Get cash fund by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCashFund()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCashFund$Response(params: {
    /**
     * The cash fund purchase id
     */
    cashFundId: number;
    context?: HttpContext;
  }): Observable<StrictHttpResponse<any>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CashFundsService.GetCashFundPath,
      'get'
    );
    if (params) {
      rb.path('cashFundId', params.cashFundId, {});
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: params?.context,
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<any>;
        })
      );
  }

  /**
   * Get cash fund by id.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCashFund$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCashFund(params: {
    /**
     * The cash fund purchase id
     */
    cashFundId: number;
    context?: HttpContext;
  }): Observable<any> {
    return this.getCashFund$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation deleteCashFund
   */
  static readonly DeleteCashFundPath = '/api/mobile/cashfunds/{cashFundId}';

  /**
   * Delete cash fund by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteCashFund()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCashFund$Response(params: {
    /**
     * The cash fund purchase id
     */
    cashFundId: number;
    context?: HttpContext;
  }): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CashFundsService.DeleteCashFundPath,
      'delete'
    );
    if (params) {
      rb.path('cashFundId', params.cashFundId, {});
    }

    return this.http
      .request(
        rb.build({
          responseType: 'text',
          accept: '*/*',
          context: params?.context,
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return (r as HttpResponse<any>).clone({
            body: undefined,
          }) as StrictHttpResponse<void>;
        })
      );
  }

  /**
   * Delete cash fund by id.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteCashFund$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCashFund(params: {
    /**
     * The cash fund purchase id
     */
    cashFundId: number;
    context?: HttpContext;
  }): Observable<void> {
    return this.deleteCashFund$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getCashFunds
   */
  static readonly GetCashFundsPath =
    '/api/mobile/cashfunds/byproject/{projectId}';

  /**
   * Get cash funds in a project.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCashFunds()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCashFunds$Response(params: {
    /**
     * The project Id
     */
    projectId: number;

    /**
     * filtro
     */
    $filter?: string;
    context?: HttpContext;
  }): Observable<StrictHttpResponse<Array<CashFund>>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CashFundsService.GetCashFundsPath,
      'get'
    );
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.query('$filter', params['$filter'], {});
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: params?.context,
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<Array<CashFund>>;
        })
      );
  }

  /**
   * Get cash funds in a project.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCashFunds$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCashFunds(params: {
    /**
     * The project Id
     */
    projectId: number;

    /**
     * filtro
     */
    $filter?: string;
    context?: HttpContext;
  }): Observable<Array<CashFund>> {
    return this.getCashFunds$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CashFund>>) => r.body as Array<CashFund>)
    );
  }

  /**
   * Path part for operation getCashFundStatus
   */
  static readonly GetCashFundStatusPath =
    '/api/mobile/cashfunds/{cashFundId}/status';

  /**
   * Get cash fund current status.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCashFundStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCashFundStatus$Response(params: {
    /**
     * The cash fund Id
     */
    cashFundId: number;
    context?: HttpContext;
  }): Observable<StrictHttpResponse<CashFundStatus>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CashFundsService.GetCashFundStatusPath,
      'get'
    );
    if (params) {
      rb.path('cashFundId', params.cashFundId, {});
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: params?.context,
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<CashFundStatus>;
        })
      );
  }

  /**
   * Get cash fund current status.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCashFundStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCashFundStatus(params: {
    /**
     * The cash fund Id
     */
    cashFundId: number;
    context?: HttpContext;
  }): Observable<CashFundStatus> {
    return this.getCashFundStatus$Response(params).pipe(
      map((r: StrictHttpResponse<CashFundStatus>) => r.body as CashFundStatus)
    );
  }

  /**
   * Path part for operation cancelCashFundTransaction
   */
  static readonly CancelCashFundTransactionPath =
    '/api/mobile/cashfunds/{cashFundId}/cancel';

  /**
   * Cancel current cash fund transaction.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cancelCashFundTransaction()` instead.
   *
   * This method doesn't expect any request body.
   */
  cancelCashFundTransaction$Response(params: {
    /**
     * The cash fund Id
     */
    cashFundId: number;
    context?: HttpContext;
  }): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CashFundsService.CancelCashFundTransactionPath,
      'put'
    );
    if (params) {
      rb.path('cashFundId', params.cashFundId, {});
    }

    return this.http
      .request(
        rb.build({
          responseType: 'text',
          accept: '*/*',
          context: params?.context,
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return (r as HttpResponse<any>).clone({
            body: undefined,
          }) as StrictHttpResponse<void>;
        })
      );
  }

  /**
   * Cancel current cash fund transaction.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cancelCashFundTransaction$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cancelCashFundTransaction(params: {
    /**
     * The cash fund Id
     */
    cashFundId: number;
    context?: HttpContext;
  }): Observable<void> {
    return this.cancelCashFundTransaction$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation activateCashFundCard
   */
  static readonly ActivateCashFundCardPath =
    '/api/mobile/cashfunds/{cashFundId}/activate';

  /**
   * Activate card for cash fund purchase.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `activateCashFundCard()` instead.
   *
   * This method doesn't expect any request body.
   */
  activateCashFundCard$Response(params: {
    /**
     * The cash fund Id
     */
    cashFundId: number;
    context?: HttpContext;
  }): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CashFundsService.ActivateCashFundCardPath,
      'post'
    );
    if (params) {
      rb.path('cashFundId', params.cashFundId, {});
    }

    return this.http
      .request(
        rb.build({
          responseType: 'text',
          accept: '*/*',
          context: params?.context,
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return (r as HttpResponse<any>).clone({
            body: undefined,
          }) as StrictHttpResponse<void>;
        })
      );
  }

  /**
   * Activate card for cash fund purchase.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `activateCashFundCard$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  activateCashFundCard(params: {
    /**
     * The cash fund Id
     */
    cashFundId: number;
    context?: HttpContext;
  }): Observable<void> {
    return this.activateCashFundCard$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation confirmCashFundPurchase
   */
  static readonly ConfirmCashFundPurchasePath =
    '/api/mobile/cashfunds/{cashFundId}/confirm';

  /**
   * Confirm cash fund purchase.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `confirmCashFundPurchase()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  confirmCashFundPurchase$Response(params: {
    /**
     * The cash fund Id
     */
    cashFundId: number;
    context?: HttpContext;
    body?: CashFundUpdateDto;
  }): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CashFundsService.ConfirmCashFundPurchasePath,
      'put'
    );
    if (params) {
      rb.path('cashFundId', params.cashFundId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'text',
          accept: '*/*',
          context: params?.context,
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return (r as HttpResponse<any>).clone({
            body: undefined,
          }) as StrictHttpResponse<void>;
        })
      );
  }

  /**
   * Confirm cash fund purchase.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `confirmCashFundPurchase$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  confirmCashFundPurchase(params: {
    /**
     * The cash fund Id
     */
    cashFundId: number;
    context?: HttpContext;
    body?: CashFundUpdateDto;
  }): Observable<void> {
    return this.confirmCashFundPurchase$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation savePaidCashFundDraft
   */
  static readonly SavePaidCashFundDraftPath =
    '/api/mobile/cashfunds/{cashFundId}/confirm/draft';

  /**
   * Save paid purchase as draft.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `savePaidCashFundDraft()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  savePaidCashFundDraft$Response(params: {
    /**
     * The cash fund Id
     */
    cashFundId: number;
    context?: HttpContext;
    body?: CashFundUpdateDto;
  }): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CashFundsService.SavePaidCashFundDraftPath,
      'put'
    );
    if (params) {
      rb.path('cashFundId', params.cashFundId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'text',
          accept: '*/*',
          context: params?.context,
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return (r as HttpResponse<any>).clone({
            body: undefined,
          }) as StrictHttpResponse<void>;
        })
      );
  }

  /**
   * Save paid purchase as draft.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `savePaidCashFundDraft$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  savePaidCashFundDraft(params: {
    /**
     * The cash fund Id
     */
    cashFundId: number;
    context?: HttpContext;
    body?: CashFundUpdateDto;
  }): Observable<void> {
    return this.savePaidCashFundDraft$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation createCashFund
   */
  static readonly CreateCashFundPath = '/api/mobile/cashfunds';

  /**
   * Create a new cash fund.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createCashFund()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCashFund$Response(params: {
    context?: HttpContext;
    body: {
      articleId?: number;
      articleDescription?: string;
      subtaskId?: number;
      comment?: string;
      isDraft?: boolean;
      isRecurringRequested?: boolean;
    };
  }): Observable<StrictHttpResponse<CashFund>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CashFundsService.CreateCashFundPath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: params?.context,
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<CashFund>;
        })
      );
  }

  /**
   * Create a new cash fund.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createCashFund$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCashFund(params: {
    context?: HttpContext;
    body: {
      articleId?: number;
      articleDescription?: string;
      subtaskId?: number;
      comment?: string;
      isDraft?: boolean;
      isRecurringRequested?: boolean;
    };
  }): Observable<CashFund> {
    return this.createCashFund$Response(params).pipe(
      map((r: StrictHttpResponse<CashFund>) => r.body as CashFund)
    );
  }

  /**
   * Path part for operation editCashFund
   */
  static readonly EditCashFundPath = '/api/mobile/cashfunds/{id}';

  /**
   * Edit a cash fund draft.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `editCashFund()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  editCashFund$Response(params: {
    id: number;
    context?: HttpContext;
    body: {
      articleId?: number;
      articleDescription?: string;
      subtaskId?: number;
      comment?: string;
      isDraft?: boolean;
      isRecurringRequested?: boolean;
    };
  }): Observable<StrictHttpResponse<CashFund>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CashFundsService.EditCashFundPath,
      'put'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: params?.context,
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<CashFund>;
        })
      );
  }

  /**
   * Edit a cash fund draft.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `editCashFund$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  editCashFund(params: {
    id: number;
    context?: HttpContext;
    body: {
      articleId?: number;
      articleDescription?: string;
      subtaskId?: number;
      comment?: string;
      isDraft?: boolean;
      isRecurringRequested?: boolean;
    };
  }): Observable<CashFund> {
    return this.editCashFund$Response(params).pipe(
      map((r: StrictHttpResponse<CashFund>) => r.body as CashFund)
    );
  }

  /**
   * Path part for operation getSubtaskBuyers
   */
  static readonly GetSubtaskBuyersPath =
    '/api/mobile/cashfunds/buyers/{subtaskId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubtaskBuyers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubtaskBuyers$Response(params: {
    subtaskId: number;
    context?: HttpContext;
  }): Observable<StrictHttpResponse<Array<UserSummary>>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CashFundsService.GetSubtaskBuyersPath,
      'get'
    );
    if (params) {
      rb.path('subtaskId', params.subtaskId, {});
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: params?.context,
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<Array<UserSummary>>;
        })
      );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSubtaskBuyers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubtaskBuyers(params: {
    subtaskId: number;
    context?: HttpContext;
  }): Observable<Array<UserSummary>> {
    return this.getSubtaskBuyers$Response(params).pipe(
      map(
        (r: StrictHttpResponse<Array<UserSummary>>) =>
          r.body as Array<UserSummary>
      )
    );
  }

  /**
   * Path part for operation putTransfer
   */
  static readonly PutTransferPath = '/api/mobile/cashfunds/{id}/transfer';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putTransfer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putTransfer$Response(params: {
    id: number;
    context?: HttpContext;
    body: {
      assignedUserId?: number;
    };
  }): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CashFundsService.PutTransferPath,
      'put'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'text',
          accept: '*/*',
          context: params?.context,
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return (r as HttpResponse<any>).clone({
            body: undefined,
          }) as StrictHttpResponse<void>;
        })
      );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `putTransfer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putTransfer(params: {
    id: number;
    context?: HttpContext;
    body: {
      assignedUserId?: number;
    };
  }): Observable<void> {
    return this.putTransfer$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation putTransferAccept
   */
  static readonly PutTransferAcceptPath =
    '/api/mobile/cashfunds/{id}/transfer/accept';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putTransferAccept()` instead.
   *
   * This method doesn't expect any request body.
   */
  putTransferAccept$Response(params: {
    id: number;
    context?: HttpContext;
  }): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CashFundsService.PutTransferAcceptPath,
      'put'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({
          responseType: 'text',
          accept: '*/*',
          context: params?.context,
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return (r as HttpResponse<any>).clone({
            body: undefined,
          }) as StrictHttpResponse<void>;
        })
      );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `putTransferAccept$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  putTransferAccept(params: {
    id: number;
    context?: HttpContext;
  }): Observable<void> {
    return this.putTransferAccept$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation putTransferReject
   */
  static readonly PutTransferRejectPath =
    '/api/mobile/cashfunds/{id}/transfer/reject';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putTransferReject()` instead.
   *
   * This method doesn't expect any request body.
   */
  putTransferReject$Response(params: {
    id: number;
    context?: HttpContext;
  }): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CashFundsService.PutTransferRejectPath,
      'put'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({
          responseType: 'text',
          accept: '*/*',
          context: params?.context,
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return (r as HttpResponse<any>).clone({
            body: undefined,
          }) as StrictHttpResponse<void>;
        })
      );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `putTransferReject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  putTransferReject(params: {
    id: number;
    context?: HttpContext;
  }): Observable<void> {
    return this.putTransferReject$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getAvailableBalance
   */
  static readonly GetAvailableBalancePath =
    '/api/mobile/cashfunds/balance/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAvailableBalance()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableBalance$Response(params: {
    id: number;
    context?: HttpContext;
  }): Observable<StrictHttpResponse<number>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CashFundsService.GetAvailableBalancePath,
      'get'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: params?.context,
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return (r as HttpResponse<any>).clone({
            body: parseFloat(String((r as HttpResponse<any>).body)),
          }) as StrictHttpResponse<number>;
        })
      );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAvailableBalance$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableBalance(params: {
    id: number;
    context?: HttpContext;
  }): Observable<number> {
    return this.getAvailableBalance$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation getCardLimits
   */
  static readonly GetCardLimitsPath = '/api/mobile/cashfunds/limit/{projectId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCardLimits()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCardLimits$Response(params: {
    projectId: number;
    context?: HttpContext;
  }): Observable<
    StrictHttpResponse<{
      dailyLimit?: number | null;
      weeklyLimit?: number | null;
      monthlyLimit?: number | null;
      yearlyLimit?: number | null;
      allTimeLimit?: number | null;
      perAuthorizationLimit?: number | null;
    }>
  > {
    const rb = new RequestBuilder(
      this.rootUrl,
      CashFundsService.GetCardLimitsPath,
      'get'
    );
    if (params) {
      rb.path('projectId', params.projectId, {});
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: params?.context,
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<{
            dailyLimit?: number | null;
            weeklyLimit?: number | null;
            monthlyLimit?: number | null;
            yearlyLimit?: number | null;
            allTimeLimit?: number | null;
            perAuthorizationLimit?: number | null;
          }>;
        })
      );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCardLimits$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCardLimits(params: {
    projectId: number;
    context?: HttpContext;
  }): Observable<{
    dailyLimit?: number | null;
    weeklyLimit?: number | null;
    monthlyLimit?: number | null;
    yearlyLimit?: number | null;
    allTimeLimit?: number | null;
    perAuthorizationLimit?: number | null;
  }> {
    return this.getCardLimits$Response(params).pipe(
      map(
        (
          r: StrictHttpResponse<{
            dailyLimit?: number | null;
            weeklyLimit?: number | null;
            monthlyLimit?: number | null;
            yearlyLimit?: number | null;
            allTimeLimit?: number | null;
            perAuthorizationLimit?: number | null;
          }>
        ) =>
          r.body as {
            dailyLimit?: number | null;
            weeklyLimit?: number | null;
            monthlyLimit?: number | null;
            yearlyLimit?: number | null;
            allTimeLimit?: number | null;
            perAuthorizationLimit?: number | null;
          }
      )
    );
  }
}
